import { useCallback, useMemo } from 'react'
import { FileBarChart } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchFraudReports, FRAUD_STR as S, type FraudReportRow } from './fraudApi'

/**
 * A25.16 — Отчёты о мошенничестве. Open-vs-resolved totals per category,
 * aggregated live from the REAL events / payments / referral-abuse feeds.
 * Placeholder permission USERS_VIEW.
 */
export function FraudReportsScreen() {
  const columns = useMemo<AdminColumn<FraudReportRow>[]>(
    () => [
      {
        key: 'category',
        header: S.category,
        type: 'enum',
        options: [
          { value: 'events', label: S.events },
          { value: 'payments', label: S.paymentFraud },
          { value: 'referral', label: S.referralAbuse },
        ],
      },
      { key: 'open', header: S.openCount, type: 'number' },
      { key: 'resolved', header: S.resolved, type: 'number' },
      { key: 'total', header: S.total, type: 'number' },
    ],
    [],
  )
  const fetcher = useCallback(fetchFraudReports, [])
  return (
    <>
      <PageHeader title={S.reports} screenId="A25.16" />
      <DataTable<FraudReportRow>
        screenId="A25.16"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => r.id}
        exportable
        emptyState={{ icon: <FileBarChart size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
